const parseError = ({ error }) => {
  if (error) {
    return new Error(error.message);
  }

  return null;
};

export default function createFBService(initializer) {
  const init = () => initializer();

  const login = () =>
    initializer().then(
      sdk =>
        new Promise((resolve, reject) => {
          sdk.getLoginStatus(response => {
            if (response.status === 'connected') {
              resolve(sdk);
            } else {
              sdk.login(loginResponse => {
                const error = parseError(loginResponse);

                if (error) return reject(error);

                if (loginResponse.status !== 'connected') {
                  return reject(new Error(`Can't connect to Facebook`));
                }

                return resolve(sdk);
              });
            }
          });
        }),
    );

  const getUserAvatar = (type = 'large') =>
    login().then(
      sdk =>
        new Promise((resolve, reject) => {
          sdk.api('me/picture', { type }, response => {
            const error = parseError(response);

            if (error) return reject(error);

            return resolve(response.data);
          });
        }),
    );

  return {
    init,
    login,
    getUserAvatar,
  };
}
